var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Djibouti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M44,24H28.356l0.008,0.005L8.676,36.842C12.345,41.215,17.845,44,24,44C35.046,44,44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M44,24c0-11.046-8.954-20-20-20c-6.156,0-11.657,2.786-15.326,7.161L28.356,24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M28.356,24L8.674,11.161C5.76,14.635,4,19.11,4,24c0,4.891,1.761,9.367,4.676,12.842l19.688-12.836 L28.356,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M13.816,24.137L16.754,22h-3.633L12,18.547L10.879,22H7.246l2.937,2.137L9.063,27.59L12,25.453 l2.938,2.137L13.816,24.137z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Djibouti);
export default __webpack_public_path__ + "static/media/icons8-djibouti.aaf239b8a1c23e660b80569e50fa70a2.svg";
export { ForwardRef as ReactComponent };